<div class="side-menu-container" [class.collapsed]="collapsed()">
    <button class="btn-collapse" (click)="toggleMenu()">
        <img [image2x]="collapsed() ? 'expand' : 'collapse'" />
    </button>

    <img class="logo" image2x="logo-rounded" />

    @if (!isTranslationsRoute()) {
        <select
            name="countries"
            id="countries"
            class="country-select"
            [ngModel]="storageService.countryCode"
            (ngModelChange)="sessionService.switchCountry($event)"
        >
            @for (option of gemUser.countries; track option.id) {
                <option [ngValue]="option.countryCode">
                    {{ collapsed() ? option.countryCode.toUpperCase() : option.name }}
                </option>
            }
        </select>
    }

    <div class="medium-container">
        @if (canAccessSitlyUsers) {
            <button
                class="menu-link filled"
                [class.center-content]="collapsed()"
                title="Screening"
                [class.active]="isScreeningRoute()"
                [class.indicator]="collapsed()"
                (click)="navigationService.navigateTo(RouteType.screening)"
            >
                <img class="highlightable" image2x="side-menu/screening" />
                @if (!collapsed()) {
                    <span class="label">Screening</span>

                    @if (warnedUsersCount > 0) {
                        <span class="counter">{{ warnedUsersCount }}</span>
                    }
                }
            </button>
        }

        @if (canAccessSitlyUsers && !collapsed() && isScreeningRoute()) {
            <div class="submenu">
                <button class="sub-menu-link" [class.active]="isScreeningGeneralRoute()" [routerLink]="screeningGeneralRouterLink">
                    General
                </button>
                <button
                    class="sub-menu-link"
                    [class.active]="isScreeningPersonalDataRoute()"
                    [routerLink]="screeningPersonalDataRouterLink"
                >
                    Personal data
                    @if (!collapsed() && usersWithPersonalDataCount > 0) {
                        <span class="counter">{{ usersWithPersonalDataCount }}</span>
                    }
                </button>
                <button
                    class="sub-menu-link"
                    [class.active]="isScreeningSensitivePhrasesRoute()"
                    [routerLink]="screeningSensitivePhrasesRouterLink"
                >
                    Phrases
                </button>
                <button class="sub-menu-link" [class.active]="isScreeningExclusionsRoute()" [routerLink]="screeningExclusionsRouterLink">
                    Exclusions
                </button>
            </div>
        }

        @if (canAccessSitlyUsers) {
            <button
                class="menu-link filled indicator"
                title="Sitly users"
                [class.center-content]="collapsed()"
                [class.active]="isUsersRoute()"
                (click)="navigationService.navigateTo(RouteType.users)"
            >
                <img class="highlightable" image2x="side-menu/user" />
                @if (!collapsed()) {
                    <span class="label">Sitly users</span>
                }
            </button>
        }

        @if (canAccessTranslations) {
            <button
                class="menu-link filled"
                title="Translations"
                [class.center-content]="collapsed()"
                [class.active]="isTranslationsRoute()"
                (click)="navigationService.navigateTo(RouteType.translations)"
            >
                <img class="highlightable" image2x="side-menu/translations" />
                @if (!collapsed()) {
                    <span class="label">Translations</span>
                }
            </button>

            @if (!collapsed() && isTranslationsRoute()) {
                <div class="submenu">
                    <button
                        class="sub-menu-link"
                        [class.active]="isTranslationsTranslateRoute()"
                        [routerLink]="translationsTranslateRouterLink"
                    >
                        Translate
                    </button>
                    @if (gemUser.role === GemUserRole.admin) {
                        <button class="sub-menu-link" [class.active]="isTranslationsAddRoute()" [routerLink]="translationsAddRouterLink">
                            Add
                        </button>
                    }
                    @if (gemUser.role === GemUserRole.admin) {
                        @if (isProd) {
                            <button
                                class="sub-menu-link"
                                [class.active]="isTranslationsPublishRoute()"
                                [routerLink]="translationsPublishRouterLink"
                            >
                                Publish
                            </button>
                        }
                        <button
                            class="sub-menu-link"
                            [class.active]="isTranslationsGroupsRoute()"
                            [routerLink]="translationsGroupsRouterLink"
                        >
                            Groups
                        </button>
                    }
                </div>
            }
        }

        @if (gemUser.role === GemUserRole.admin) {
            <button
                class="menu-link filled indicator"
                title="Subscriptions"
                [class.center-content]="collapsed()"
                [class.active]="isSubscriptionsRoute()"
                (click)="navigationService.navigateTo(RouteType.subscriptions)"
            >
                <img class="highlightable" image2x="side-menu/subscription" />
                @if (!collapsed()) {
                    <span class="label">Subscriptions</span>
                }
            </button>
        }

        @if (gemUser.role === GemUserRole.admin || gemUser.role === GemUserRole.customerResearcher) {
            <button
                class="menu-link filled"
                title="User feedback"
                [class.active]="isFeedbacksRoute()"
                [class.center-content]="collapsed()"
                (click)="navigationService.navigateTo(RouteType.feedbacks)"
            >
                <img class="highlightable" image2x="side-menu/thumbs-up" />
                @if (!collapsed()) {
                    <span class="label">User feedback</span>
                }
            </button>
        }
    </div>

    <div class="bottom-container">
        @if (gemUser.role === GemUserRole.admin) {
            <button
                class="menu-link indicator"
                [class.center-content]="collapsed()"
                [class.active]="isSettingsRoute()"
                title="Settings"
                (click)="navigationService.navigateTo(RouteType.settings)"
            >
                <img [image2x]="isSettingsRoute() ? 'side-menu/settings-active' : 'side-menu/settings'" />
                @if (!collapsed()) {
                    <span class="label">Settings</span>
                }
            </button>
        }

        <button class="menu-link" [class.center-content]="collapsed()" title="Logout" (click)="sessionService.signOut()">
            <img image2x="side-menu/logout" />
            @if (!collapsed()) {
                <span class="label">Logout</span>
            }
        </button>
    </div>
</div>
